module.exports = __webpack_public_path__ + "static/media/london.0a154b12.jpg";